import React, {Component} from 'react';
import {fabric} from 'fabric';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { SketchPicker } from 'react-color';

class ShapeTool extends Component{
    static defaultProps = {
        canvas:null,
        className:'left'
    };
    
    constructor(props){
        super(props);
        this.state = {
            displayBgColorPicker:false,
            displayStrokeColorPicker:false,
            bgColor:'#000',
            strokeColor:'#000',
            strokeWidth:0,
            shape:null
        };

        this.onChangeBgColor = this.onChangeBgColor.bind(this);
        this.onChangeStrokeColor = this.onChangeStrokeColor.bind(this);
        this.onChangeStrokeWidth = this.onChangeStrokeWidth.bind(this);
        
        this.addRect = this.addRect.bind(this);
        this.addTriangle = this.addTriangle.bind(this);
        this.addCircle = this.addCircle.bind(this);
    
        this.onSelectionCleared = this.onSelectionCleared.bind(this);
        this.onSelectionUpdated = this.onSelectionUpdated.bind(this);
        this.initCanvasEvent();
    }

    

    componentDidUpdate(prevProps, prevState){
        if( null!==this.props.canvas && null===prevProps.canvas ){
            this.initCanvasEvent();
        }
    }

    initCanvasEvent(){
        if( null===this.props.canvas ) return;
        this.props.canvas.on('selection:created', this.onSelectionUpdated);
        this.props.canvas.on('selection:updated', this.onSelectionUpdated);
        this.props.canvas.on('selection:cleared', this.onSelectionCleared);
    }

    componentWillUnmount(){
        this.props.canvas.off('selection:created', this.onSelectionUpdated);
        this.props.canvas.off('selection:updated', this.onSelectionUpdated);
        this.props.canvas.off('selection:cleared', this.onSelectionCleared);
    }


    onSelectionUpdated(event){
        const selecttedItem = event.selected[0];
        
        if(selecttedItem.isType('rect') || selecttedItem.isType('circle') || selecttedItem.isType('triangle')){
            const shape = selecttedItem;
            this.setState({
                shape:shape,
                bgColor:(shape.fill===null?'#000':shape.fill),
                strokeColor: (shape.stroke===null?'#000':shape.stroke),
                strokeWidth:shape.strokeWidth,
                displayBgColorPicker:false,
                displayStrokeColorPicker:false
            });
        }else{
            this.setState({shape:null, displayBgColorPicker:false, displayStrokeColorPicker:false})
        }
    }

    onSelectionCleared(event){
        this.setState({ shape:null });
    }

    onChangeBgColor(color){
        if(color==='transparent'){
            this.state.shape.set('fill', 'transparent');
        }else{
            this.setState({bgColor:color.hex});
            this.state.shape.set('fill', color.hex);
        }
        this.props.canvas.renderAll();
    }

    onChangeStrokeColor(color){
        if(color==='transparent'){
            this.state.shape.set('stroke', 'transparent');
        }else{
            this.setState({strokeColor:color.hex});
            this.state.shape.set('stroke', color.hex);
        }
        this.props.canvas.renderAll();
    }

    onChangeStrokeWidth(value){
        this.setState({strokeWidth:value});
        this.state.shape.set('strokeWidth', value);
        this.props.canvas.renderAll();
    }


    addRect(){
        var object = new fabric.Rect({ width: 100, height: 100, opacity: 1 });
        this.props.canvas.add(object);
        this.props.canvas.setActiveObject(object);
        object.center();
    }

    addTriangle(){
        var object = new fabric.Triangle({ width: 100, height: 100,  opacity: 1, stroke:'#000' });
        this.props.canvas.add(object);
        this.props.canvas.setActiveObject(object);
        object.center();
    }

    addCircle(){
        var object = new fabric.Circle({ radius:50,  opacity: 1, stroke:'#000' });
        this.props.canvas.add(object);
        this.props.canvas.setActiveObject(object);
        object.center();
    }

    renderShapeOption(){
        if(null===this.state.shape)return null;
        
        return (
            <div className="options">
                <div className="option colorPicker">
                    <div className="label">배경 색</div>
                    <div className="swatch" onClick={()=>{this.setState({displayBgColorPicker:!this.state.displayBgColorPicker})}}>
                        <div className="color" style={ {background:`${this.state.bgColor}`}} />
                    </div>
                    <div className="swatch transparent" onClick={ ()=>{ this.onChangeBgColor('transparent')}}>
                        <i className="far fa-eye-slash"></i>
                    </div>
                    
                    { this.state.displayBgColorPicker &&
                        <div className="popover">
                            <div className="cover" onClick={ ()=>{this.setState({displayBgColorPicker:false})} }/>
                            <SketchPicker color={ this.state.bgColor } onChange={ this.onChangeBgColor } />
                        </div>
                    }
                </div>

                <div className="option colorPicker">
                    <div className="label">선 색</div>
                    <div className="swatch" onClick={()=>{this.setState({displayStrokeColorPicker:!this.state.displayStrokeColorPicker})}}>
                        <div className="color" style={ {background:`${this.state.strokeColor}`}} />
                    </div>
                    <div className="swatch transparent" onClick={ ()=>{ this.onChangeStrokeColor('transparent')}}>
                        <i className="far fa-eye-slash"></i>
                    </div>
                    
                    { this.state.displayStrokeColorPicker &&
                        <div className="popover">
                            <div className="cover" onClick={ ()=>{this.setState({displayStrokeColorPicker:false})} }/>
                            <SketchPicker color={ this.state.strokeColor } onChange={ this.onChangeStrokeColor } />
                        </div>
                    }
                </div>
                <div className="option strokeWidth">
                    <div className="label">선 굵기 <span className="value">{this.state.strokeWidth}</span></div>
                    <Slider min={0} max={50} value={this.state.strokeWidth} onChange={this.onChangeStrokeWidth}  tipFormatter={value=>`${value}$`} />
                </div>

            </div>
        );
    }

    render(){
        if(this.props.canvas===null)return null;
        
        return (
            <div className="drawingToolContainer">
                <div className="controls text-center">
                    <button onClick={this.addRect}>
                        <img src={`${process.env.PUBLIC_URL}/static/images/picture/btn_shape_rect.png`} alt="사각형" />
                    </button>
                    <button onClick={this.addTriangle}>
                        <img src={`${process.env.PUBLIC_URL}/static/images/picture/btn_shape_triangle.png`} alt="삼각형" />
                    </button>
                    <button onClick={this.addCircle}>
                        <img src={`${process.env.PUBLIC_URL}/static/images/picture/btn_shape_circle.png`} alt="원" />
                    </button>
                </div>
                {this.renderShapeOption()}
            </div>
        );
    }
}


export default ShapeTool;